import {
  CURRENT_COMPANY_ID_HEADER_KEY,
  SILENT_REQUEST_HEADER_KEY,
} from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";
import { ConversationHubPagedResultDto } from "@hd/types/dto/contact/conversation-hub-paged-result.dto";
import { NotificationsMessage } from "@hd/types/dto/realtime-message/notifications-message.dto";
import { useQuery } from "@tanstack/react-query";

type QueryParams = {
  companyId: number | null;
  take: number;
};

const apiUrl = "/realtimemessage/get-last-preview-unread-messages";

const fetchData = async (
  params: QueryParams
): Promise<ConversationHubPagedResultDto<NotificationsMessage>> => {
  const result = await httpClient.post<
    ConversationHubPagedResultDto<NotificationsMessage>
  >(
    import.meta.env.VITE_HD_API_URL + apiUrl,
    {
      ...params,
      companyId: undefined,
    },
    {
      headers: {
        [CURRENT_COMPANY_ID_HEADER_KEY]: params.companyId,
        [SILENT_REQUEST_HEADER_KEY]: true,
      },
    }
  );

  const parsedItems = result.data.items.map((item) => ({
    ...item,
    sentDate: new Date(item.sentDate),
  }));

  return {
    ...result.data,
    items: parsedItems,
  };
};

export const lastPreviewUnreadMessagesQueryKey = (params: QueryParams) => [
  "lastPreviewUnreadMessages",
  params,
];

export const useLastPreviewUnreadMessagesQuery = (
  params: QueryParams,
  enabled: boolean
) => {
  return useQuery({
    // staleTime: 10000 * 60,
    queryKey: lastPreviewUnreadMessagesQueryKey(params),
    queryFn: () => fetchData(params),
    enabled: !!params.companyId && enabled,
  });
};
